import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  page: {
    id: 'gold.transactionlog.page',
    defaultMessage: 'Transaction Log',
  },

  transactionsTitle: {
    id: 'gold.transactionlog.page',
    defaultMessage: 'Transaction Log',
  },

  table: {
    no: {
      id: 'gold.table.no',
      defaultMessage: 'No',
    },
    public: {
      id: 'gold.table.public',
      defaultMessage: 'DANA Public ID',
    },
    merchant: {
      id: 'gold.table.merchant',
      defaultMessage: 'Merchant Order ID',
    },
    paymentOption: {
      id: 'gold.table.paymentOption',
      defaultMessage: 'Payment Option',
    },
    phone: {
      id: 'gold.table.phone',
      defaultMessage: 'Phone Number',
    },
    trxDate: {
      id: 'gold.table.trxDate',
      defaultMessage: 'Transaction Date',
    },
    trxType: {
      id: 'gold.table.trxtype',
      defaultMessage: 'Transaction Type',
    },
    gram: {
      id: 'gold.table.gram',
      defaultMessage: 'Amount in Gram',
    },
    idr: {
      id: 'gold.table.idr',
      defaultMessage: 'Amount in IDR',
    },
    fee: {
      id: 'gold.table.fee',
      defaultMessage: 'Fee',
    },
    state: {
      id: 'gold.table.state',
      defaultMessage: 'State',
    },
    status: {
      id: 'gold.table.status',
      defaultMessage: 'Status',
    },
    action: {
      id: 'gold.table.action',
      defaultMessage: 'Action',
    },
  },

  disburse: {
    retry: {
      id: 'gold.disburse.retry',
      defaultMessage: 'Retry',
    },
    noRetry: {
      id: 'gold.disburse.noRetry',
      defaultMessage: 'No Action',
    },
  },

  validation: {
    min: {
      id: 'gold.min',
      defaultMessage: 'Minimum Amount',
    },
    max: {
      id: 'gold.max',
      defaultMessage: 'Maximum Amount',
    },
  },
});
